import { site } from "../../data/siteConfig";
import { JotformEmbed } from "./JotformEmbed";
import { PrototypeBookingFlow } from "./PrototypeBookingFlow";

// Booking boundary: the site owns branding & marketing; Jotform will own real
// availability, intake, deposits and confirmations. Set
// REACT_APP_JOTFORM_BOOKING_URL in frontend/.env to switch to production mode.
export const BookingEmbed = () =>
  site.jotformBookingUrl ? (
    <JotformEmbed url={site.jotformBookingUrl} />
  ) : (
    <PrototypeBookingFlow />
  );

